import cimg from '../Images/home.svg';
const NEETData = [{
        id: 1,
        cname: "Complete Co-ordinate Geometry |JEE Mains and Advanced|",
        cimage: cimg,
        tname: "By Kdm Sir",
        crate: "3",
        cprice: "INR 4000/-"
    },
    {
        id: 2,
        cname: "Complete Co-ordinate Geometry |JEE Mains and Advanced|",
        cimage: cimg,
        tname: "By Kdm Sir",
        crate: "3",
        cprice: "INR 4000/-"
    },
    {
        id: 3,
        cname: "Complete Co-ordinate Geometry |JEE Mains and Advanced|",
        cimage: cimg,
        tname: "By Kdm Sir",
        crate: "3",
        cprice: "INR 5/-"
    },
    {
        id: 4,
        cname: "Complete Co-ordinate Geometry |JEE Mains and Advanced|",
        cimage: cimg,
        tname: "By Kdm Sir",
        crate: "3",
        cprice: "INR 4000/-"
    },
    {
        id: 5,
        cname: "Complete Co-ordinate Geometry |JEE Mains and Advanced|",
        cimage: cimg,
        tname: "By Kdm Sir",
        crate: "3",
        cprice: "INR 4000/-"
    },
    {
        id: 6,
        cname: "Complete Co-ordinate Geometry |JEE Mains and Advanced|",
        cimage: cimg,
        tname: "By Kdm Sir",
        crate: "3",
        cprice: "INR 5/-"
    },
    // {
    //     id: 4,
    //     cname: "Complete Co-ordinate Geometry |JEE Mains and Advanced|",
    //     cimage: cimg,
    //     crate: "3",
    //     cprice: "INR 4000/-"
    // },
];
export default NEETData;